import { observer } from 'mobx-react';
import * as React from 'react';
import { Grid, GridColumn } from 'telia-front-react';
import { useStores } from '../../stores/RootStore';
import RequestCallbackForm from './RequestCallbackForm';
import RequestCallbackPreview from './RequestCallbackPreview';
import RequestCallbackSuccess from './RequestCallbackSuccess';

const RequestCallback = observer((): React.JSX.Element => {
  const { callbackStore, ssoStore } = useStores();

  React.useEffect(() => {
    if (ssoStore.loggedIn) {
      updateReservationFormFromSession();
    }
  }, [ssoStore.auth]);

  const updateReservationFormFromSession = () => {
    callbackStore.prefillReservationCreation({
      name: ssoStore.loggedIn ? ssoStore.customer.displayName : '',
      customerId: ssoStore.customerId
    });
  };

  const renderStep = (): React.JSX.Element => {
    if (['SUCCESS'].includes(callbackStore.callbackCreationResult.status)) {
      return <RequestCallbackSuccess />;
    }

    if (['ERROR', 'INVALID_INPUT', 'SENDING', 'PREVIEW'].includes(callbackStore.callbackCreationResult.status)) {
      return <RequestCallbackPreview />;
    }

    return <RequestCallbackForm />;
  };

  return (
    <Grid align={['middle-xs']}>
      <GridColumn width={['md-6', 'xs-12']}>{renderStep()}</GridColumn>
    </Grid>
  );
});

export default RequestCallback;
